module.exports = "<div\r\n\tclass=\"tab-content\"\r\n\tv-show=\"isSelected\">\r\n\t<slot v-if=\"isShownFirstTime\"></slot>\r\n</div>\r\n"